import React from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { ChangeForm } from 'js/components/common/ChangeForm';

import * as Types from './types';
import * as hooks from './hooks';
import { DEFAULT_QUESTIONNAIRE_FORM } from './constants';

import style from './QuestionnairePopup.scss';

export const changeFormClassNames = {
    form: style.form
};

export const QuestionnairePopup: React.FC<Types.IQuestionnairePopupProps> = ({
    id,
    title,
    onSuccess,
    tkPrefix,
    onClose,
    formName,
    daydepositlimit,
    weekdepositlimit,
    monthdepositlimit
}) => {
    const closePopup = useCombinedOnClose(onClose, id);
    const onSubmit = hooks.useOnSubmit({
        tkPrefix,
        onSuccess,
        closePopup,
        daydepositlimit,
        weekdepositlimit,
        monthdepositlimit
    });

    return (
        <ManagedPopup
            title={title}
            onClose={closePopup}
            className={style.container}
            layerClassNames={{ layout: style.layout }}
        >
            <ChangeForm
                classNames={changeFormClassNames}
                formName={formName || DEFAULT_QUESTIONNAIRE_FORM}
                onSubmit={onSubmit}
            />
        </ManagedPopup>
    );
};
